<template>
    <material-card >
          <template #heading>
            <v-toolbar color="secondary">
              <v-toolbar-title>
                <v-icon> mdi-google-classroom </v-icon>
                {{$t('users')}}
              </v-toolbar-title>

              <v-divider vertical  class="mx-2"/>
              <v-text-field class mx-2
                        v-model="search"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                    ></v-text-field>
            </v-toolbar>
          </template>
          <v-data-table
            :items="users"
            :headers="usersHeader"
            :search="search" :footer-props="{ showFirstLastPage: true}"
          >
          <template v-slot:[`item.hasJoinedVoice`]="{ item }">
            <span>{{ $t(item.hasJoinedVoice) }}</span>
        </template>
        <template v-slot:[`item.hasVideo`]="{ item }">
            <span>{{ $t(item.hasVideo) }}</span>
        </template>
        <template v-slot:[`item.isListeningOnly`]="{ item }">
            <span>{{ $t(item.isListeningOnly) }}</span>
        </template>
        <template v-slot:[`item.isPresenter`]="{ item }">
            <span>{{ $t(item.isPresenter) }}</span>
        </template>
        <template v-slot:[`item.role`]="{ item }">
            <span>{{ $t(item.role) }}</span>
        </template>
        </v-data-table>
        </material-card>
    </template>
    <script>
    export default {
      name: "BBBMeetingUsers",
      props: [
        'users'
    ],
      data() {
        return {
        
          usersHeader: [
          { value: "fullName", text: this.$t("name") },
          { value: "hasJoinedVoice", text: this.$t("has_joined_voice") },
          { value: "hasVideo",text: this.$t("has_video")},
          { value: "isListeningOnly",text: this.$t("is_listening_only")},
          { value: "isPresenter",text: this.$t("is_presenter")},
          { value: "role",text: this.$t("role")},
        ],
          search:''
        };
      },
      mounted(){
        
      }
     
     
    };
    </script>
    <style>
    .text-content-left input {
      text-align: left !important;
    }
    </style>
    